import { TableFilter, TableFilterExpression } from './types';

export const addFilterExpression = <Filter extends TableFilter>(
  filterExpression: TableFilterExpression<Filter>,
  filterExpressions: TableFilterExpression<Filter>[]
) => {
  return [...filterExpressions, filterExpression];
};

export const upsertFilterExpression = <Filter extends TableFilter>(
  filterExpression: TableFilterExpression<Filter>,
  filterExpressions: TableFilterExpression<Filter>[]
) => {
  const index = filterExpressions.findLastIndex(
    f => f.filterId === filterExpression.filterId
  );
  if (index !== -1) {
    return [
      ...filterExpressions.slice(0, index),
      filterExpression,
      ...filterExpressions.slice(index + 1),
    ];
  }
  return [...filterExpressions, filterExpression];
};
